import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { describe } from '@amzn/stencil-react-desc';
import { withTestAttributes } from "../utils";
import Text from "./Text";
export var createSemanticTextComponent = function createSemanticTextComponent(tag, defaultProps) {
  // Capitalize the first letter of the tag name
  var componentName = "".concat(tag.charAt(0).toUpperCase()).concat(tag.substr(1));
  var HeadingComponent = Text.withComponent(tag, {
    target: "e16nynr70"
  });
  HeadingComponent.defaultProps = _objectSpread(_objectSpread({}, Text.defaultProps), defaultProps);
  var DocumentedHeadingComponent = describe(HeadingComponent).description("Text with ".concat(tag, " tag"));
  DocumentedHeadingComponent.propTypes = _objectSpread({}, Text.describedPropTypes);
  var ComponentWithTestAttributes = withTestAttributes({
    component: "Stencil".concat(componentName)
  })(DocumentedHeadingComponent);
  ComponentWithTestAttributes.displayName = componentName;
  return ComponentWithTestAttributes;
};